import { i18next } from '@/i18n'

export default {
  path: 'portals/',
  meta: {
    title: i18next.t('routes.diffusion'),
    auth: 'ROLE_USER'
  },
  component: () =>
    import(/* webpackChunkName: "portals" */ '@/pages/portals/Portals.vue'),
  children: [
    {
      path: '',
      name: 'portals',
      meta: {
        title: i18next.t('routes.diffusionsListTitle')
      },
      component: () =>
        import(
          /* webpackChunkName: "portals" */ '@/pages/portals/PortalsList.vue'
        )
    },
    {
      path: 'portal-seloger/',
      name: 'portalSeloger',
      meta: {
        title: i18next.t('routes.diffusionSelogerTitle')
      },
      component: () =>
        import(
          /* webpackChunkName: "portals" */ '@/pages/portals/PortalSeloger.vue'
        )
    },
    {
      path: 'social-managment/',
      name: 'portalsSocialManagment',
      meta: {
        title: i18next.t('routes.portalsSocialManagmentTitle')
      },
      component: () =>
        import(
          /* webpackChunkName: "portals" */ '@/pages/portals/PortalsSocialManagment.vue'
        )
    },
    {
      path: 'selection/:post',
      name: 'portals-selection-post',
      meta: {
        title: i18next.t('routes.diffusionSelectionTitle')
      },
      component: () =>
        import(
          /* webpackChunkName: "portals" */ '@/pages/portals/PortalsSecondaryList.vue'
        )
    },
    {
      path: 'report/:portal',
      name: 'report',
      meta: {
        title: i18next.t('routes.diffusionReportTitle')
      },
      component: () =>
        import(/* webpackChunkName: "portals" */ '@/pages/report/ReportByPortal.vue')
    },
    {
      path: 'broadcast/:portal',
      name: 'broadcast',
      meta: {
        title: i18next.t('routes.adsSelectionTitle')
      },
      component: () =>
        import(
          /* webpackChunkName: "portals" */ '@/pages/portals/Broadcast.vue'
        )
    },
    {
      path: 'portals-posts/',
      name: 'portals-posts',
      meta: {
        title: i18next.t('routes.diffusionsPerAdTitle')
      },
      component: () =>
        import(
          /* webpackChunkName: "portals" */ '@/pages/portals/PortalsListPosts.vue'
        )
    },
    {
      path: 'quotas/',
      name: 'quotas',
      meta: {
        title: i18next.t('routes.quotas')
      },
      component: () =>
        import(
          /* webpackChunkName: "portals" */ '@/pages/portals/Quotas'
        )
    }
  ]
}
